/**
 * Returns a frame between 0 and `loopDurationFrames` that represents the
 * progress of a loop.
 */
export function getLoopProgressAsFrame({ frame, progressOffset = 0, loopDurationFrames, }) {
    return (frame + progressOffset * loopDurationFrames) % loopDurationFrames;
}
